import { CANCEL } from "redux-saga";
import {  getInstance, axiosInstance} from "./axios-instance";
import sls from "single-line-string";
import { push } from "connected-react-router";
import { getAccessToken, saveToken, getToken, deleteToken } from "./local-storage";
import { store } from "../../store";
import { ACCOUNT_URI } from "./constants";

let isTokenRefreshing = false;
let subscribers = [];
const onAccessTokenFetched = accessToken => subscribers.map(s => s(accessToken));

export const generateNewAccessToken = () => getNewToken().then(response => saveToken(response.data))

const getNewToken = () => {
	let token = getToken()
	return getInstance().post(`${ACCOUNT_URI}/RefreshToken`, {
		RefreshToken: token.refreshToken,
		ExpiredToken: token.accessToken,
	});
};

const http = (interceptors, isCancelable=true) => {

	let localAxiosInstance = isCancelable ? getInstance(window.location.pathname) : axiosInstance().value;

	for (let i = 0; i < interceptors.request?.length; i++) {
		localAxiosInstance.interceptors.request.use(interceptors.request[i]);
	}

	localAxiosInstance.interceptors.request.use(request => {
		if (request.method == "get") request.url = sls`${request.url}`;

		request.headers["Authorization"] = `Bearer ${getAccessToken()}`;
		return request;
	});

	localAxiosInstance.interceptors.response.use(
		response => response,
		error => {
			if (error?.response?.status === 401) {
				const {
					config,
					response: { status, headers },
				} = error;

				const originalRequest = config;
				const tokenExpired = headers["token-expired"];

				if (tokenExpired) {
					if (!isTokenRefreshing) {
						isTokenRefreshing = true;
						getNewToken()
							.then(response => {
								const { data } = response;
								isTokenRefreshing = false;
								saveToken(data);
								onAccessTokenFetched(getAccessToken());
								subscribers = [];
							})
							.catch(error => {
								isTokenRefreshing = false;
								deleteToken();
								store.dispatch(push("/login"));
								Promise.resolve();
							});
					}

					const retryOriginalRequest = new Promise(resolve => {
						subscribers.push(accessToken => {
							originalRequest._retry = true;
							originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
							resolve(localAxiosInstance(originalRequest));
						});
					});
					return retryOriginalRequest;
				} else {
					if (!localAxiosInstance.isCancel(error)) {
						deleteToken();
						store.dispatch(push("/login"));
					}
				}
			} else return Promise.reject(error);
		}
	);

	for (let i = 0; i < interceptors.response?.length; i++) {
		localAxiosInstance.interceptors.response.use(interceptors.response[i]);
	}

	return localAxiosInstance;
};

export default {
	get: (url, config = {}, isCancelable = true) => {
		const request = http(interceptors, isCancelable).get(url, { ...config });
		return request;
	},
	post: (url, object, config = {}) => {
		const request = http(interceptors).post(url, object, {
			...config,
		});
		return request;
	},
	put: (url, object) => {
		const request = http(interceptors).put(url, object);
		return request;
	},
	patch: (url, object) => {
		const request = http(interceptors).patch(url, object);
		return request;
	},
	delete: url => {
		const request = http(interceptors).delete(url);
		return request;
	},
};

export const interceptors = {
	request: [],
	response: [],
};
